import { Stopover } from '../../../types';
import { DocumentsConsentsDescription } from './documentsConsentsDescription';

type DocumentsConsentsDataProps = {
  activeKey: string | string[];
  onOpenPanel: (panel: string | string[]) => void;
  selectedStopover: Stopover;
  setSelectedStopover?: (stopover: Stopover) => void;
};
export function DocumentsConsentsData(props: DocumentsConsentsDataProps) {
  const { activeKey, onOpenPanel, selectedStopover, setSelectedStopover } =
    props;

  return (
    <DocumentsConsentsDescription
      activeKey={activeKey}
      onOpenPanel={onOpenPanel}
      selectedStopover={selectedStopover}
      setSelectedStopover={setSelectedStopover}
    />
  );
}
